module.exports = __webpack_public_path__ + "static/banner-56279a4184de707f8e86b63dd3e12f1e.svg";